import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  UtilityBillsTableRow,
  EmptyStateContainer,
  Loader
} from '../../../../neoverv';
//import tap from '../../../../assets/images/module/general/TapIconBlue.svg';
//import MeterIcon from '../../../../assets/images/module/general/blueEmptyMeter.svg';
import moment from 'moment';
import { setTenantBills } from '../../../../redux/action/UtilityBilling/UtilityBillingActions';
import Autoload from '../../../../neoverv/Autoload';
import { isStarterTier } from '../../../../helpers/subscriptionFeatureAccess';
//import Logo from '../../../../assets/images/module/general/Logo.svg';
import html2canvas from 'html2canvas';
import jsPdf from 'jspdf';
//import Html from 'react-pdf-html';
import { PDFDownloadLink, Document, Page } from 'react-pdf';
import { browserName } from "react-device-detect";

import $ from 'jquery';
import {
  Table, 
  TableBody, 
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@material-ui/core';
import { showNotification } from '@mantine/notifications';
import RedCross from '../../../../assets/images/module/general/RedCross.svg';
import GreenTick from '../../../../assets/images/module/general/GreenTick.svg';
import { formatNumber } from '../../../../helpers/stringsManipulations';
import UtilityBillTable from './UtilityBillTable';
import MeterReadingsTable from './MeterReadingsTable';
import MeterDataHandler from '../../../../neoverv/helpers/DataHandler/Meter';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import CompositionOfHeatingCostsTable from './CompositionOfHeatingCostsTable';
import CostSplitWarmWaterAndHeatingTable from './CostSplitWarmWaterAndHeatingTable';
import SplitBaseConsumptionCosts from './SplitBaseConsumptionCosts';
import imageCompression from 'browser-image-compression';
import EnergyConsumptionAndCO2EmissionsCostTable from './EnergyConsumptionAndCO2EmissionsCostTable';
import CompareHeatingConsumptionBarChart from './CompareHeatingConsumptionBarChart';
import BenchmarkingAverageUserBuilding from './BenchmarkingAverageUserBuilding';
import CalculationOfCO2TaxTable from './CalculationOfCO2TaxTable';
import accounting from 'accounting';
import { getPdfDefaultLogo, getPdfLogoWidth } from '../../../../helpers/pdfBranding';

var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];
const { yearDifferenceMoment, checkProperty, loader, checkEnvironment, errorHandlingForPDF } = Autoload.MainHelper;
const MOBILE_SIZE = 766;
let allBills = [];
const ref = React.createRef();
const btnRef = React.createRef();
const Logo = "data:image/svg+xml;base64,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";
const tap = "data:image/svg+xml;base64,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";
const MeterIcon = "data:image/svg+xml;base64,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";

export class UtilityBillsTable extends Component {
  static propTypes = {
    prop: PropTypes,
  };

  tableHeadCellStyling = {
    color: 'rgb(114, 114, 147)',//'#727293',
    padding: '1mm',
    fontWeight: '500',
    whiteSpace: 'nowrap',
    margin: '0px',
    fontSize: '7pt',
    lineHeight: '11pt',
    border: '1px solid #DADAE6',
    textTransform: 'capitalize',
    height: '0px',
    // borderBottom: 'none',
    // borderRight: 'none',
    textAlign: 'left'
  }

  tableBodyCellStyling = {
    color: '#0e0e1d',
    padding: '5px 9px 5px 9px',
    fontWeight: '400',
    whiteSpace: 'nowrap',
    fontSize: '14px',
    lineHeight: '20px',
    border: '1px solid #DADAE6',
    textTransform: 'capitalize',
    height: '48px',
    minWidth: '90px',
    // borderBottom: 'none',
    // borderRight: 'none'
  }

  state = {
    selectedTenantID: '1',
    DropdownState: 'true',
    isMobile: window.innerWidth <= MOBILE_SIZE,
    showEmpty: true,
    utilityData: {
      date: '',
      recordStatus: 'last',
    },
    utilityBillTableData: null,
    selectedTenantData: null,
    invoiceData: null,
    warmWaterCostTypeFound: false,
    readings: null,
    files: [],
    heatingCosts:[],

    meterReadingsSwitch: false,
    compositionOfHeatingCostsSwitch: false,
    costSplitWarmWaterAndHeatingSwitch: false,
    splitBaseConsumptionCostsSwitch: false,
    energyConsumptionCO2EmissionsSwitch: false,
    compareHeatingConsumptionBarChartSwitch: false,
    energyLevelsInfoSwitch: false,
    arbitraryBoardInfoSwitch: false,
    energyAdviceCenterInfoSwitch: false,
    co2TaxInfoSwitch: false,
    vatSwitch: false,
    laborCostSwitch: false,
    pages: '',
    customImageBase64: null,
    logo: null,
    allPdfs: [],
    houseTenantAverageBase64Url: null,
    isPreTaxInfoHidden: false,
    heatingFilter: false,
    areCostsFetched: false,
    areReadingsFetched: false
  };

  componentDidMount() {
    const {messagePreview=false} = this.props;
    if(messagePreview === false){
      this.componentDidMountStuffWithoutMessagePreview();
    }else{
      this.componentDidMountStuffWithMessagePreview();
    }
  }

  componentDidMountStuffWithoutMessagePreview=()=>{
    let url = new URL(window.location.href);
    let {meterReadingsSwitch, compositionOfHeatingCostsSwitch, costSplitWarmWaterAndHeatingSwitch, splitBaseConsumptionCostsSwitch, vatSwitch, laborCostSwitch, energyConsumptionCO2EmissionsSwitch, compareHeatingConsumptionBarChartSwitch, energyLevelsInfoSwitch, arbitraryBoardInfoSwitch, energyAdviceCenterInfoSwitch, co2TaxInfoSwitch, isPreTaxInfoHidden, heatingFilter} = this.state;
    meterReadingsSwitch = JSON.parse(url.searchParams.get("meterReadings"));
    compositionOfHeatingCostsSwitch= JSON.parse(url.searchParams.get("compositionOfHeatingCosts"));
    costSplitWarmWaterAndHeatingSwitch= JSON.parse(url.searchParams.get("costSplitWarmWaterAndHeating"));
    splitBaseConsumptionCostsSwitch= JSON.parse(url.searchParams.get("splitBaseConsumptionCosts"));
    vatSwitch= JSON.parse(url.searchParams.get("vatSwitch"));
    laborCostSwitch= JSON.parse(url.searchParams.get("laborCostSwitch"));
    energyConsumptionCO2EmissionsSwitch= JSON.parse(url.searchParams.get("energyConsumptionCO2EmissionsSwitch"));
    compareHeatingConsumptionBarChartSwitch= JSON.parse(url.searchParams.get("compareHeatingConsumptionBarChartSwitch"));
    energyLevelsInfoSwitch= JSON.parse(url.searchParams.get("energyLevelsInfoSwitch"));
    arbitraryBoardInfoSwitch= JSON.parse(url.searchParams.get("arbitraryBoardInfoSwitch"));
    energyAdviceCenterInfoSwitch= JSON.parse(url.searchParams.get("energyAdviceCenterInfoSwitch"));
    co2TaxInfoSwitch= JSON.parse(url.searchParams.get("co2TaxInfoSwitch"));
    isPreTaxInfoHidden= JSON.parse(url.searchParams.get("isPreTaxInfoHidden"));
    heatingFilter= JSON.parse(url.searchParams.get("heatingFilter"));
    this.setState({
      meterReadingsSwitch,
      compositionOfHeatingCostsSwitch,
      costSplitWarmWaterAndHeatingSwitch,
      splitBaseConsumptionCostsSwitch,
      vatSwitch,
      laborCostSwitch,
      energyConsumptionCO2EmissionsSwitch,
      compareHeatingConsumptionBarChartSwitch,
      energyLevelsInfoSwitch,
      arbitraryBoardInfoSwitch,
      energyAdviceCenterInfoSwitch,
      co2TaxInfoSwitch,
      isPreTaxInfoHidden,
      heatingFilter
    })
    var loaderWhole = document.getElementById('hello-housing-loader');
    loaderWhole.style.display = 'block';
    var loaderBackground = document.getElementById('hh_loader_bg');
    var loader = document.getElementById('hh_loader_spinner');
    loaderBackground.style.background = 'white';
    loaderBackground.style.opacity = '1';
    loader.style.zIndex = 9999999999;
    loaderBackground.style.zIndex = 999999999;
    const id = window.location.pathname.split('/')[2];

    let pages = 1;
    pages = this.props.propertySelected.propertyType === 'REGULAR' ? (((meterReadingsSwitch ? 1 : 0) + ((heatingFilter && (compositionOfHeatingCostsSwitch || costSplitWarmWaterAndHeatingSwitch || splitBaseConsumptionCostsSwitch)) ? 1 : 0) + ((heatingFilter && (energyConsumptionCO2EmissionsSwitch || compareHeatingConsumptionBarChartSwitch || co2TaxInfoSwitch)) ? 1 : 0) + ((arbitraryBoardInfoSwitch || (heatingFilter && energyAdviceCenterInfoSwitch) || (heatingFilter && energyLevelsInfoSwitch)) ? 1 : 0)) + 1) : 1;
    this.setState({pages}, ()=> {
      var downloadStatus = document.getElementById('download_status');
      downloadStatus.style.display = 'block';
      downloadStatus.textContent=`PDF-Dokumente erstellen ${0} / ${this.state.pages}`;
    })

    this.props.companyLogoEnable === 'UserDefined' && this.getAccountPicture();
    this.callApis(id);

    let logo = new XMLSerializer().serializeToString(document.getElementById("logo"));
    this.setState({logo});
    let data = this.props.utilityBillingData.find((ub) => ub.id == this.props.currentDataId);
    // if (this.props.tenantBills.length) {
    //   const selectedTenantData = this.props.tenantBills[0]?.billingData?.tenantBills[0];
    //   this.setState({ selectedTenantData });
    // }
    // console.log('data CDM', data);
    // let diff = yearDifferenceMoment(data.date.split('-')[0])
    if (data !== undefined) {
      this.setState({
        utilityData: {
          date: data && data?.date ? data?.date : '',
          recordStatus: data && data?.recordStatus ? data?.recordStatus : 'last',
          isSecured: data && data?.isSecured ? data?.isSecured : false,
          data: data
        },
      });
    }

    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  componentDidMountStuffWithMessagePreview=()=>{
    let {meterReadingsSwitch, compositionOfHeatingCostsSwitch, costSplitWarmWaterAndHeatingSwitch, splitBaseConsumptionCostsSwitch, vatSwitch, laborCostSwitch, energyConsumptionCO2EmissionsSwitch, compareHeatingConsumptionBarChartSwitch, energyLevelsInfoSwitch, arbitraryBoardInfoSwitch, energyAdviceCenterInfoSwitch, co2TaxInfoSwitch, id, isPreTaxInfoHidden, heatingFilter} = this.props;
    this.setState({
      meterReadingsSwitch,
      compositionOfHeatingCostsSwitch,
      costSplitWarmWaterAndHeatingSwitch,
      splitBaseConsumptionCostsSwitch,
      vatSwitch,
      laborCostSwitch,
      energyConsumptionCO2EmissionsSwitch,
      compareHeatingConsumptionBarChartSwitch,
      energyLevelsInfoSwitch,
      arbitraryBoardInfoSwitch, 
      energyAdviceCenterInfoSwitch,
      co2TaxInfoSwitch,
      isPreTaxInfoHidden,
      heatingFilter
    })

    //window.location.pathname.split('/')[2];

    let pages = 1;
    pages = this.props.propertySelected.propertyType === 'REGULAR' ? (((meterReadingsSwitch ? 1 : 0) + ((heatingFilter && (compositionOfHeatingCostsSwitch || costSplitWarmWaterAndHeatingSwitch || splitBaseConsumptionCostsSwitch)) ? 1 : 0) + ((heatingFilter && (energyConsumptionCO2EmissionsSwitch || compareHeatingConsumptionBarChartSwitch || co2TaxInfoSwitch)) ? 1 : 0) + ((arbitraryBoardInfoSwitch || (heatingFilter && energyAdviceCenterInfoSwitch) || (heatingFilter && energyLevelsInfoSwitch)) ? 1 : 0)) + 1) : 1;
    this.setState({pages});

    this.props.companyLogoEnable === 'UserDefined' && this.getAccountPicture();
    
    this.callApis(id);

    let logo = new XMLSerializer().serializeToString(document.getElementById("logo"));
    this.setState({logo});
    let data = this.props.utilityBillingData.find((ub) => ub.id == this.props.currentDataId);
    if (data !== undefined) {
      this.setState({
        utilityData: {
          date: data && data?.date ? data?.date : '',
          recordStatus: data && data?.recordStatus ? data?.recordStatus : 'last',
          isSecured: data && data?.isSecured ? data?.isSecured : false,
          data: data
        },
      });
    }

    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  }

  getAccountPicture=()=>{
    fetch(Autoload.Setting.account_api_baseurl + this.props.accountData.accountId +'/picture/download', 
    {
      method: 'GET',
      headers: {
        'Content-Type': 'octet-stream',
        'Authorization': Autoload.Utils.getAuthToken()
      }
    }).then(response => {
      response.blob()
      .then(async blob => {
        const options = {
          maxSizeMB: 0.1,
          maxWidthOrHeight: 400,
          useWebWorker: true
        }
        try {
          let fileNew = new File([blob], "my_image.png",{type:"image/png", lastModified:new Date().getTime()});
          
          const compressedFile = await imageCompression(fileNew, options);
          console.log('compressedFile instanceof Blob', compressedFile instanceof Blob); // true
          console.log(`compressedFile size ${compressedFile.size / 1024} KB`); // smaller than maxSizeMB
          
          var reader = new FileReader();
          reader.readAsDataURL(compressedFile); 

          const setState=(base64)=>{
            this.setState({customImageBase64: base64 ? base64 : null});
          }
          
          reader.onloadend = function() {
            var base64data = reader.result;                
            console.log('base64data: ', base64data);
            setState(base64data);
          }
        } catch (error) {
          console.log('getAccountPicture: ', error);
        }



        // console.log('getAccountPicture: ', blob);
        // const url =URL.createObjectURL(blob);
        // this.setState({customImageBase64: blob.size > 0 ? url : null});
        // console.log('getAccountPicture: url:', url);
        }).catch(e1=> console.log('getAccountPicture: error1: ', e1))
    }).catch(e=> console.log('getAccountPicture: error: ', e))
  }

  // calculateTotal=(i)=>{
  //   let total=0;
  //   this.state.selectedTenantData.tenantRows.map((row, index)=> {
  //     if(index <= i){
  //       total = total + row.tenantCostShare;
  //     }
  //   })
  //   console.log('calculateTotal: ', total);
  //   return formatNumber(total, true);;
  // }

  calculateTotal=(i, deCurrency=true, type)=>{
    if(type === 'heating'){
      let total = this.state.selectedTenantData.totalAllocatedHeatingCosts;
      console.log('calculateTotal: ', total);
      return deCurrency === false ? total : formatNumber(total, true);
    }else{
      let total = 0;
      this.state.selectedTenantData.tenantRows.map((row, index)=> {
        console.log('row: ', row);
        if(row.costType !== "Heizung & Heizungswartung"){
          if(index <= i){
            total = total + row.tenantCostShare;
          }
        }
      })
      console.log('calculateTotal: ', total);
      return deCurrency === false ? total : formatNumber(total, true);
    }
  }

  getInvoiceData = (id) => {
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'billingStatements/' + id,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleGetInvoice',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  _handleGetInvoice = (response) => {
    console.log('get billing statement', response);
    if (response.status === false && response.message !== 'Not Found') {
      // Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_error_not_found);
    }
    this.setState({ invoiceData: response.result });
  };

  updateConsumptions = () => {
    // loader(true);
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'updateConsumptions/' + this.props.currentDataId,
      'PUT',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleUpdateConsumptionsResponse',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };
  handleUpdateConsumptionsResponse = (response) => {
    !response.status && console.log('Update Consumptions Failed');

    //loader(false);
    // this.callApis();
  };

  callApis = (id) => {
    // loader(true);
    allBills = [];
    this.getHeatingCosts();
    //get all billing statements
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'billingStatements/' + id,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleGetBS',
      null,
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };
  
  checkAndDownloadPDF = () => {
    const { meterReadingsSwitch, areCostsFetched, areReadingsFetched } = this.state;
    
    if (areCostsFetched && (!meterReadingsSwitch || areReadingsFetched)) {
      setTimeout(() => {
        const captureElement = document.querySelector("#capture");
        
        if (captureElement) {
          html2canvas(captureElement, { scale: 2, useCORS: true }).then(canvas => { 
            let url = canvas.toDataURL();
            const targetImage = document.getElementById("house-tenant-average-image");
            
            if (targetImage) {
              targetImage.src = url;
            }
            
            setTimeout(() => {
              this.downloadPdfFromServer(0);
            }, 100);
            
          }).catch(e => {
             console.error('html2canvasError: ', e);
             this.downloadPdfFromServer(0);
          });
        } else {
          this.downloadPdfFromServer(0);
        }
      }, 500);
    }
  };

  _handleGetBS = (response) => {
    console.log('response1 Billing Statement', response);
    if (response.status === false && response.message !== 'Not Found') {
      // Autoload.Redirection.redirection_error();
      Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_error_not_found);
      loader(false);
    }
    if (response.result) {
      const bs = response.result;
      this.state.meterReadingsSwitch && this._getOccupationReadingTenants(checkProperty(bs, 'tenantId'));
      let data = {
        tenantID: checkProperty(bs, 'tenantId'),
        tenantName: checkProperty(bs, 'tenantName'),
        stayedFor: checkProperty(checkProperty(bs, 'tenantOccupation'), 'totalDays'),
        totalAllocations: checkProperty(bs, 'totalAllocatedUtilityCosts'),
        prepayments: checkProperty(bs, 'totalAdvancePayments'),
        billingStatementId: checkProperty(bs, 'id'),
        utilityBillingId: checkProperty(bs, 'utilityBillingId'),
        rentalUnitId: checkProperty(bs, 'rentalUnitId'),
        tenantOccupation: checkProperty(bs, 'tenantOccupation'),
      };
      const billingId = checkProperty(bs, 'billingStatementId')
        ? checkProperty(bs, 'billingStatementId')
        : checkProperty(bs, 'id');
      //get pdf for each record
      this._handleGetBSpdf(data.utilityBillingId, billingId);
      this.setState({ invoiceData: response.result, selectedTenantData: {...this.state.selectedTenantData, ...response.result} });
    } else {
      //store empty array to tenantBills field of redux
      setTimeout(() => {
        this.downloadPdfFromServer(0);
      }, 500);
      this.props.setTenantBills(allBills);
      this.setState({ showEmpty: false });
      //loader(false);
    }
    
  };

  _handleGetBSpdf = (ubId, bsId) => {
    let url = new URL(window.location.href);
    var heatingFilter = this.props.messagePreview ? this.props.heatingFilter : (url.searchParams.get("heatingFilter") === 'true');
    console.log('_handleGetBSpdf: ', heatingFilter);
    //call apis for tenantRows
    heatingFilter ?
    Autoload.HttpRequestAxios.HttpRequest(
      // Autoload.Setting.swagger_mocked_api_baseUrl +
      //   'costAllocations/forBillingStatement?utilityBillingId=' +
      //   response.other.BSData.utilityBillingId +
      //   '&billingStatementId=' +
      //   response.other.BSData.billingStatementId,
      Autoload.Setting.ub_api_base_url +
        'costAllocations/forBillingStatement?utilityBillingId=' +
        ubId +
        '&billingStatementId=' +
        bsId,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleGetBSRows',
      {},
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    )
    : 
    Autoload.HttpRequestAxios.HttpRequest(
      // Autoload.Setting.swagger_mocked_api_baseUrl +
      //   'costAllocations/forBillingStatement?utilityBillingId=' +
      //   response.other.BSData.utilityBillingId +
      //   '&billingStatementId=' +
      //   response.other.BSData.billingStatementId,
      Autoload.Setting.ub_api_base_url +
        'costAllocations/forBillingStatement?utilityBillingId=' +
        ubId +
        '&billingStatementId=' +
        bsId +
        '&filter=non-heating',
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleGetBSRows',
      {},
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    )
  };
  _handleGetBSRows = (response) => {
    console.log('response2 forBillingStatement', response);
    let formattedResponse = [];
    if (response.status === false) {
      // Autoload.Redirection.redirection_error();
      //Autoload.DataHandlerGeneral.GeneralErrorMessage(true, lang.newKeys.text_error_not_found);
      // showNotification({
      //   //title:'Fehler',
      //   message: 'Es gibt noch keine Betriebskostenabrechnung.',
      //   icon: <img src={RedCross} alt='red-tick'/>,
      // })
      this.setState({ areCostsFetched: true }, () => {
         this.checkAndDownloadPDF();
      });
      return;
    }

    if (response.result.length > 0) {
      console.log('formattedResponse', formattedResponse);
      formattedResponse = response.result.map((tr) => ({
        // id: checkProperty(tr, 'id'),
        id: checkProperty(tr, 'id'),
        costType: checkProperty(tr, 'costTypeName'),
        totalCost: checkProperty(tr, 'totalCostShare'),
        allocationKey: checkProperty(tr, 'allocationTypeName'),
        totalValue: checkProperty(tr, 'totalConsumption'),
        tenantValue: checkProperty(tr, 'tenantConsumption'),
        unit: checkProperty(tr, 'consumptionUnits'),
        tenantCostShare: checkProperty(tr, 'tenantCostShare'),
        comment: checkProperty(tr, 'comment'),
        utilityBillingId: checkProperty(tr, 'utilityBillingId'),
        costPositionId: checkProperty(tr, 'costPositionId'),
        billingStatementId: checkProperty(tr, 'billingStatementId'),
        tenantName: checkProperty(tr, 'tenantName'),
        rentalUnitId: checkProperty(tr, 'rentalUnitId'),
        rentalUnitName: checkProperty(tr, 'rentalUnitName'),
        tenantOccupation: checkProperty(tr, 'tenantOccupation'),
        costTypeIdentifier: checkProperty(tr, 'costTypeIdentifier')
      }));
      let warmWaterCostTypeFound = formattedResponse.find((row)=> row.costType === 'Warmwasser (Verbrauch)') !== undefined ? true : false;

      //merge data in array
      // allBills.push(mergedData);
      // const data = allBills.find((ub) => ub.utilityBillingId == this.props.currentDataId);
      // console.log('allBills', allBills, mergedData, this.props.currentDataId, data);
      // this.props.setTenantBills(allBills);
      // const { allTenantBills } = this.getAllData();

      // loader(true);
      this.setState(
        {
          selectedTenantData: { ...this.state.selectedTenantData, tenantRows: formattedResponse },
          warmWaterCostTypeFound,
          areCostsFetched: true
        },
        () => {
          //loader(false)
          // btnRef.current.click()
          this.checkAndDownloadPDF();
        }
      );
    } else {
      // loader(false);
      this.setState({
          selectedTenantData: { ...this.state.selectedTenantData, tenantRows: [] },
          areCostsFetched: true
      }, () => {
          this.checkAndDownloadPDF();
      });
    }
  };

  getTableLabels = () => {
    return (
      <TableRow>
        <TableCell style={this.tableHeadCellStyling}>{lang.utility.text_cost_type}</TableCell>
        <TableCell style={{...this.tableHeadCellStyling, ...{textAlign: 'right'}}}>{lang.utility.text_total_cost}</TableCell>
        <TableCell style={this.tableHeadCellStyling}>{lang.utility.text_allocation_key}</TableCell>
        <TableCell style={{...this.tableHeadCellStyling, ...{textAlign: 'right'}}}>{lang.utility.text_total_value}</TableCell>
        <TableCell style={{...this.tableHeadCellStyling, ...{textAlign: 'right'}}}>{lang.utility.text_tenant_value}</TableCell>
        <TableCell style={{...this.tableHeadCellStyling, ...{textAlign: 'right'}}}>{lang.utility.text_unit}</TableCell>
        <TableCell style={{...this.tableHeadCellStyling, ...{textAlign: 'right'}}}>{lang.utility.text_tenant_cost_share}</TableCell>
        <TableCell style={{...this.tableHeadCellStyling, ...{borderRight: '1px solid #DADAE6'}}}>{lang.utility.text_comment}</TableCell>
      </TableRow>
    );
  };
  getAllData = () => {
    console.log('get All data func ');
    const { utilityBillingData } = this.props;
    let currentBillingData = utilityBillingData.find((ub) => ub.id == this.props.currentDataId);
    let allTenantBills =
      currentBillingData &&
      currentBillingData.billingData &&
      currentBillingData.billingData.tenantBills &&
      currentBillingData.billingData.tenantBills;
    let currentTenant =
      Array.isArray(allTenantBills) &&
      allTenantBills.find((tb) => tb.billingStatementId == this.state.selectedTenantID);
    // console.log('getData', allTenantBills, currentTenant)
    return {
      currentTenant: currentTenant ? currentTenant : {},
      allTenantBills: Array.isArray(allTenantBills) && allTenantBills.length > 0 ? allTenantBills : [],
    };
  };

  updateCommentLocalState = (tenantId, billId, value) => {
    // loader(true);
    this.setState({
      utilityBillTableData: {
        ...this.state.utilityBillTableData,
        tenantRows: this.state.utilityBillTableData.tenantRows.map((i) =>
          i.id === billId ? { ...i, comment: value } : i
        ),
      },
    });
  };

  downloadPDF = (file) => {
    window.open(file, '_blank');
  };
  calculateBalance = (data) => {
    const { totalAllocations, prepayments } = data.currentTenant;
    return parseFloat(totalAllocations) - parseFloat(prepayments);
  };
  getBalance(data) {
    var totalAllocations = checkProperty(data, 'totalAllocations', '-');
    var prePayments = checkProperty(data, 'prepayments', '-');
    // console.log(data)
    // console.log(totalAllocations)
    // console.log(prePayments)
    var getbalance = totalAllocations - prePayments + '€';
    return getbalance === 'NaN€' ? '-' : getbalance;
  }
  handleResize = () => {
    window.innerWidth <= MOBILE_SIZE ? this.setState({ isMobile: true }) : this.setState({ isMobile: false });
  };
  onInputChange = (field, value) => {
    const selectedTenantData = this.props.tenantBills[0]?.billingData?.tenantBills?.filter(
      (o) => o.tenantID === value
    )[0];
    // console.log(selectedTenantData)
    this.setState({ [field]: value, selectedTenantData }, () => console.log(this.state.selectedTenantData));
  };

  async printDocument(index, count) {
    const {meterReadingsSwitch, compositionOfHeatingCostsSwitch, costSplitWarmWaterAndHeatingSwitch, splitBaseConsumptionCostsSwitch, energyConsumptionCO2EmissionsSwitch, compareHeatingConsumptionBarChartSwitch, energyLevelsInfoSwitch, arbitraryBoardInfoSwitch, energyAdviceCenterInfoSwitch, co2TaxInfoSwitch, readings, customImageBase64, selectedTenantData } = this.state;
    let meterReadingsLength = readings && readings.meterReadings ? readings.meterReadings.length : 0;
    var downloadStatus = document.getElementById('download_status');
    const input = document.getElementById(`divToPrint${index}`);
    const input1 = document.getElementById('divToPrint1');
    let {files, pages} = this.state;
    let delay = selectedTenantData?.tenantRows?.length > 10 ? 3000 : 1600;
    const logo = document.getElementById('logo');
    const emptyLogo = document.getElementById('emptyLogo');
    
    const logoWidth = this.props.companyLogoEnable === 'UserDefined' ? this.props.accountData.pictureLocation !== null ? logo.offsetWidth : getPdfLogoWidth(logo) : getPdfLogoWidth(logo);
    const logoHeight = this.props.companyLogoEnable === 'UserDefined' ? this.props.accountData.pictureLocation !== null ? logo.offsetHeight : 38 : 38;
    //var s = index === 1 && new XMLSerializer().serializeToString(document.getElementById("emptyLogoMeter"))
    const emptyLogoMeter = document.getElementById('emptyLogoMeter');
    const propertyName= this.props.currentProperty?.propertyAdress?.streetno ? this.props.currentProperty?.propertyAdress?.streetno : this.props.currentProperty.name;
    const rentalUnitName= this.state.invoiceData?.rentalUnitName;
    const tenantName= this.state.invoiceData?.tenantName;
    const closeWindow = ()=> {
      var allowDownloadSafari = document.getElementById('allow_download');
      allowDownloadSafari.style.display = browserName === 'Safari' && 'block'; 
      var spinner = document.getElementById('hh_loader_spinner');
      browserName !== 'Safari' ? loader(false) : spinner.style.display = 'none';
      browserName !== 'Safari' && window.close();
    }
    console.log('emptyLogoMeter: ', emptyLogoMeter);
    if((index === 1 && !meterReadingsSwitch) || (index === 2 && (!compositionOfHeatingCostsSwitch && !costSplitWarmWaterAndHeatingSwitch && !splitBaseConsumptionCostsSwitch && !energyConsumptionCO2EmissionsSwitch && !compareHeatingConsumptionBarChartSwitch && !energyLevelsInfoSwitch))){
      setTimeout(() => {
        this.printDocument(index+1, count+1);  
      }, delay);
    }else{
      await html2canvas(logo, {
        scale: 4
      }).then(async(canvas) => {
        const imgData = this.props.companyLogoEnable === 'UserDefined' ? (customImageBase64 !== null ? customImageBase64 : canvas.toDataURL('image/png'))  : canvas.toDataURL('image/png');
        var doc = new jsPdf("p", "pt", 'a4');
        console.log('imgData: ', imgData);
        doc.addImage(imgData, 'JPEG', 34.5, 20, logoWidth, logoHeight, undefined, 'FAST');
        /////////////////////
        doc.setFontSize(8);
        var text = `${this.props.accountData.addressCompany && (this.props.accountData.addressCompany + ', ')}${this.props.accountData.addressStreet && (this.props.accountData.addressStreet + ',')} ${(this.props.accountData.addressZipCode)} ${this.props.accountData.addressCity}`,
        xOffset = doc.internal.pageSize.width/2; 
        var pageSize = doc.internal.pageSize;
        var pageHeight = pageSize.height
          ? pageSize.height
          : pageSize.getHeight();
        
        doc.setTextColor('#828282');
        !isStarterTier(this.props.currentSubscription) && doc.text(text, 
        xOffset, 
        pageHeight - 30,
        {align: 'center'});
        /////////////////////
        // var pageSize = doc.internal.pageSize;
        // var pageWidth = pageSize.width
        // ? pageSize.width
        // : pageSize.getWidth();
        // doc.setFontSize(8);
        // doc.setTextColor('#000000');
        // doc.text(`Seite ${count > pages ? pages : count} von ${pages}`, 
        // pageWidth - 40, 
        // 26,
        // {align: 'center'});
        ////////////////////
        if(this.props.propertySelected.propertyType === 'REGULAR' ? count <= 3 : count < 2){
          //console.log('this.state.selectedTenantData: ', this.state.selectedTenantData);
          if(index === 0 ? this.state.selectedTenantData : true){
            if(index === 1 && meterReadingsLength === 0){
              await html2canvas(emptyLogoMeter, {
                scale: 4
              }).then((canvas1)=>{
                const imgData1 = canvas1.toDataURL('image/png');
                doc.addImage(imgData1, 'JPEG',290, 355, 10,10, undefined, 'FAST');
                doc.html(input, {
                  callback: async function (doc) {
                    downloadStatus.textContent=`PDF-Dokumente erstellen ${count > pages ? pages : count} / ${pages}`;
                    await files.push(doc.output('arraybuffer'));
                    // doc.save(`${propertyName}-${rentalUnitName}-${tenantName ? tenantName.replace(/,/g, '_') : 'Mieter'}.pdf`, {returnPromise: true}).then(
                    //   setTimeout(() => {
                    //     //closeWindow();
                    // }, 500))
                  },
                  margin: [50,24,62,24],
                  x: 10,
                  y: 0,
                  autoPaging: 'text',
                  html2canvas: {useCORS: true, scale: 0.505
                    , height: 0 },
                })
              });
            }else{
              doc.html(input, {
                callback: async function (doc) {
                  downloadStatus.textContent=`PDF-Dokumente erstellen ${count > pages ? pages : count} / ${pages}`;
                  await files.push(doc.output('arraybuffer'));
                  // doc.save(`${propertyName}-${rentalUnitName}-${tenantName ? tenantName.replace(/,/g, '_') : 'Mieter'}.pdf`, {returnPromise: true}).then(
                  //   setTimeout(() => {
                  //    // closeWindow();
                  // }, 500))
                },
                margin: [50,24,62,24],
                x: 10,
                y: 0,
                autoPaging: 'text',
                html2canvas: {useCORS: true, scale: 0.505
                  , height: 0 },
              })
            }
          }else{
            await html2canvas(emptyLogo, {
              scale: 4
            }).then((canvas1)=>{
              const imgData1 = canvas1.toDataURL('image/png');
              doc.addImage(imgData1, 'JPEG',290, 445, 10,10, undefined, 'FAST');
              doc.html(input, {
                callback: async function (doc) {
                  downloadStatus.textContent=`PDF-Dokumente erstellen ${count > pages ? pages : count} / ${pages}`;
                  await files.push(doc.output('arraybuffer'));
                  // doc.save(`${propertyName}-${rentalUnitName}-${tenantName ? tenantName.replace(/,/g, '_') : 'Mieter'}.pdf`, {returnPromise: true}).then(
                  //   setTimeout(() => {
                  //     //closeWindow();
                  // }, 500))
                },
                margin: [50,24,62,24],
                x: 10,
                y: 0,
                autoPaging: 'text',
                html2canvas: {useCORS: true, scale: 0.505
                  , height: 0 },
              })
            });
          }
            

          this.setState({files});
            setTimeout(() => {
                this.printDocument(index+1, count+1);  
            }, delay);
        }
        else{
          downloadStatus.textContent=`PDF-Dokumente zusammenfügen...`;
          setTimeout(() => {
            console.log('this.state.files: ', this.state.files);
              const pdfBytes = this.mergePdfs(this.state.files);
              pdfBytes.then(function(result) {
                  var blob = new Blob([result], {type: "application/pdf"});
                  var link = document.createElement('a');
                  link.href = window.URL.createObjectURL(blob);
                  //var fileName = reportName;
                  link.download = `${propertyName}-${rentalUnitName}-${tenantName ? tenantName.replace(/,/g, '_') : 'Mieter'}.pdf`;
                  link.click();
                  setTimeout(() => {
                      closeWindow();
                  }, 500);
              })
              console.log('pdfBytes: ', pdfBytes);
          }, delay);
      }
      });
    }
  }
  async mergePdfs(pdfsToMerge) {
    try {
      console.log('mergePdfs', pdfsToMerge);
      const mergedPdf = await PDFDocument.create();
      const font = await mergedPdf.embedStandardFont(StandardFonts.Helvetica);
  
      const createInnerPromise = async (arrayBuffer) => {
        const pdf = await PDFDocument.load(arrayBuffer);
        return await mergedPdf.copyPages(pdf, pdf.getPageIndices());
      };
    
      const outerPromise = pdfsToMerge.map((arrayBuffer) => {
        const innerPromise = createInnerPromise(arrayBuffer);
        return innerPromise;
      });
    
      const resultOuterPromise = await Promise.all(outerPromise);
    
      let count = 0;
      let totalPages = 0;
      resultOuterPromise.forEach((pageArray, i) => {
        pageArray.forEach((page, index) => {
          totalPages = totalPages + 1;
        })
      });
      resultOuterPromise.forEach((pageArray, i) => {
        pageArray.forEach((page) => {
          const { width, height } = page.getSize();
          page.drawText(`Seite ${count+1} von ${totalPages}`, {
            x: width - 75.5,
            y: height - 34, //height - 47,
            size: 6,
            color: rgb(0.4470588235294118, 0.4470588235294118, 0.5803921568627451),
          })
    
          //add footer
          // var text = `${this.props.accountData.addressCompany && (this.props.accountData.addressCompany + ', ')}${this.props.accountData.addressStreet && (this.props.accountData.addressStreet + ',')} ${(this.props.accountData.addressZipCode)} ${this.props.accountData.addressCity}`;
          // const textWidth = font.widthOfTextAtSize(text, 8);
          // !isStarterTier(this.props.currentSubscription) && page.drawText(text, {
          //   x: page.getWidth() / 2 - textWidth / 2,
          //   y: height - (height-30),
          //   size: 8,
          //   color: rgb(0, 0, 0)//rgb(0.5, 0.5, 0.5)
          // })
          //
          mergedPdf.addPage(page);
          count = count + 1;
        });
      }); 
      return (await mergedPdf.save()).buffer;
    } catch (error) {
      console.log('mergePdfsError: ', error);
    }
  }
  heatingRow =(index)=>{
    return (
      <TableRow>
        <TableCell style={{...this.tableBodyCellStyling, ...{textAlign: 'right', borderBottom: this.state.selectedTenantData.tenantRows.length === (index + 1) && '1px solid #DADAE6'}}} colSpan={7}>
          Heizkosten gesamt
        </TableCell>
        <TableCell style={{...this.tableBodyCellStyling, ...{fontWeight: 'bold', borderBottom: this.state.selectedTenantData.tenantRows.length === (index + 1) && '1px solid #DADAE6'}}} colSpan={1}>
          {this.calculateTotal(index)}
        </TableCell>
      </TableRow>
    );
  }
  utilityTotalRow=(index)=>{
    return(
    <TableRow>
      <TableCell style={{...this.tableBodyCellStyling, ...{textAlign: 'right'}}} colSpan={1}>
        Betriebskosten gesamt
      </TableCell>
      <TableCell style={{...this.tableBodyCellStyling, ...{fontWeight: 'bold'}}} colSpan={1}>
        {this.calculateTotal(index)}
      </TableCell>
      <TableCell style={{...this.tableBodyCellStyling, ...{textAlign: 'right'}}} colSpan={2}>
        Vorauszahlungen
      </TableCell>
      <TableCell style={{...this.tableBodyCellStyling, ...{fontWeight: 'bold'}}} colSpan={2}>
        {this.state.selectedTenantData ? Autoload.MainHelper.ConverterCurrencyDe_DisplayOnly(this.state.selectedTenantData.prepayments, false) + ' €' : '0,00 €'}
      </TableCell>
      <TableCell style={{...this.tableBodyCellStyling, ...{textAlign: 'right'}}} colSpan={1}>
        {this.state.selectedTenantData ? this.state.selectedTenantData.prepayments - this.state.selectedTenantData.totalAllocations >= 0 ? lang.utility.text_balance_positive : lang.utility.text_balance_negative : lang.utility.text_balance}
      </TableCell>
      <TableCell style={{...this.tableBodyCellStyling, ...{fontWeight: 'bold'}}} colSpan={1}>
        {this.state.selectedTenantData
        ? Autoload.MainHelper.ConverterCurrencyDe_DisplayOnly(this.state.selectedTenantData.prepayments - this.state.selectedTenantData.totalAllocations, false) + ' €'
        : '0,00 €'}
      </TableCell>
    </TableRow>);
  }

  getOccupationPeriodDate(periodStart, periodEnd) {
    const occupationStartDate = moment(periodStart, 'YYYY-MM-DD').format('DD.MM.YYYY');
    const occupationEndDate = moment(periodEnd, 'YYYY-MM-DD').format('DD.MM.YYYY');
    return occupationStartDate + ' - ' + occupationEndDate;
  }

  updateOccasion() {
    const { defaultOccasion, tenantOccupationReadings } = this.state;
    console.log('tenantOccupationReadings', tenantOccupationReadings);
    let readingList = [];
    let readingType = null;
    const { periodStartReading = null, periodEndReading = null } = tenantOccupationReadings;
    if (periodStartReading && periodStartReading?.occasionDate >= tenantOccupationReadings.periodStart) {
    console.log('periodStartReading');
      const periodReading = {
        ...periodStartReading,
        periodStart: tenantOccupationReadings.periodStart,
        periodEnd: tenantOccupationReadings.periodEnd,
        rentalUnitName: tenantOccupationReadings.rentalUnitName,
        tenantFullName: tenantOccupationReadings.tenantFullName,
        tenantId: tenantOccupationReadings.tenantId,
        occupationId: tenantOccupationReadings.id,
        occupationId: tenantOccupationReadings.id,
        vacant: tenantOccupationReadings.vacant,
        startReadingOccasion: periodStartReading?.occasion
      }
      this.setState({readings: periodReading, readingsSwitch: true});
    };
    if (periodEndReading) {
      console.log('periodEndReading');
      let { meterReadings } = periodEndReading;
      meterReadings= meterReadings.map((meterReading)=> {
        const meterReadingsFromPeriodStartReading = periodStartReading.meterReadings.find((meterReading1)=> meterReading1.meter.meterId === meterReading.meter.meterId);
        console.log('meterReadingsFromPeriodStartReading: ', meterReadingsFromPeriodStartReading);
        if(meterReadingsFromPeriodStartReading !== undefined){
          meterReading.startValue = meterReadingsFromPeriodStartReading.currentValue;
          meterReading.consumption = (meterReading.meter.hkaEvaluationFactor === null && (meterReading.currentValue === null || meterReading.startValue === null)) ? null : meterReading.currentValue - meterReading.startValue;
        }
        return meterReading;
      });
      const periodReading = {
        ...periodEndReading,
        periodStart: tenantOccupationReadings.periodStart,
        periodEnd: tenantOccupationReadings.periodEnd,
        rentalUnitName: tenantOccupationReadings.rentalUnitName,
        tenantFullName: tenantOccupationReadings.tenantFullName,
        tenantId: tenantOccupationReadings.tenantId,
        occupationId: tenantOccupationReadings.id,
        occupationId: tenantOccupationReadings.id,
        vacant: tenantOccupationReadings.vacant,
        occasion: periodEndReading?.occasion,
        startReadingOccasion: periodStartReading?.occasion
      }
      this.setState({readings: periodReading, readingsSwitch: true});
    };
    this.setState({ areReadingsFetched: true }, () => {
      this.checkAndDownloadPDF();
    });
  }

  downloadPdfFromServer=(count)=>{
    const {meterReadingsSwitch, compositionOfHeatingCostsSwitch, costSplitWarmWaterAndHeatingSwitch, splitBaseConsumptionCostsSwitch, energyConsumptionCO2EmissionsSwitch, compareHeatingConsumptionBarChartSwitch, energyLevelsInfoSwitch, arbitraryBoardInfoSwitch, energyAdviceCenterInfoSwitch, co2TaxInfoSwitch, heatingFilter} = this.state;
    const {messagePreview=false, getPdfUrl, profileData} = this.props;

    console.log('downloadPdfFromServer_123: ', messagePreview);
    var downloadStatus = document.getElementById('download_status');
    const closeWindow = ()=> {
      var allowDownloadSafari = document.getElementById('allow_download');
      allowDownloadSafari.style.display = browserName === 'Safari' && 'block'; 
      var spinner = document.getElementById('hh_loader_spinner');
      browserName !== 'Safari' ? loader(false) : spinner.style.display = 'none';
      browserName !== 'Safari' && window.close();
    }
    const downloadPage=()=>{
      const {accountData, propertySelected, currentSubscription} = this.props;
      const data = new FormData();
      let html = document.getElementById(`divToPrint${count}`);
      console.log('html: ', html, count);
      let doc = document.implementation.createHTMLDocument("New Document");
      try {
        doc.body.appendChild(html);
        const blob = new Blob([doc.documentElement.innerHTML], {
          type: 'text/html'
        });
        
        const fileName = `billingstatement-${propertySelected.name}-${new Date().valueOf()}}`;
        let file = new File([blob], fileName);
        file.originalname = fileName;
        console.log('downloadPdfFromServer: ', file);
        // var a = document.createElement("a");
        // document.body.appendChild(a);
        // let url = window.URL.createObjectURL(file);
        // a.href = url;
        // a.download = 'test.html';
        // a.click();
        // window.URL.revokeObjectURL(url);

        // this.downloadPdfFromServer(count+1);

        data.append('file', file);
        data.append('isPageNumberInHeaderEnabled', false);
        if(!isStarterTier(currentSubscription)){
          let footer = `${accountData.addressCompany && (accountData.addressCompany + ', ')}${accountData.addressStreet && (accountData.addressStreet + ',')} ${(accountData.addressZipCode)} ${accountData.addressCity}`;
          console.log('propertySelectedsadfadg: ', propertySelected);
          if(propertySelected?.isPropertyOwnerInfoEnabled && propertySelected?.isPropertyOwnerInfoInMessagesEnabled){
            const {propertyOwner} = propertySelected;
            footer = `${propertyOwner?.name && (propertyOwner?.name + ', ')}${propertyOwner?.street && (propertyOwner?.street + ', ')}${(propertyOwner?.postalCode)} ${propertyOwner?.city}`;
            data.append('footer', footer);
          }else{
            data.append('footer', footer);
          }
        }
        let url = `https://${checkEnvironment()}.hellohousing.de/api/reporting-api/pdf`;
        fetch(url,
          {
            method: 'POST',
            body: data,
            headers: {
              Authorization: Autoload.Utils.getAuthToken(),
            }
          }).then((response)=> {
            if(response.status === 200){
              response.blob()
              .then(data => {
                downloadStatus.textContent=`PDF-Dokumente erstellen ${count > this.state.pages ? this.state.pages : count} / ${this.state.pages}`;
                this.convertBlobToArrayBuffer(data).then((value)=> {
                  let {allPdfs} = this.state;
                  allPdfs.push(value);
                  this.setState({allPdfs});
                  this.downloadPdfFromServer(count+1);  
                })
                
              }).catch(e=> console.log('reporting-api/pdf: ', e))
            }else{
              errorHandlingForPDF(response, this.props.profileData, url);
            }
          }).catch(e=> console.log('reporting-api/pdf: ', e))
          
      } catch (e) {
        console.log('reporting-api/pdf: ', e);
      }
    }
    if(count < 5) {
      if(count === 0){
        setTimeout(() => {
          downloadPage();  
        }, 500);
      }else if(count === 1 && meterReadingsSwitch){
        downloadPage();
      }else if(count === 2 && heatingFilter && (compositionOfHeatingCostsSwitch || costSplitWarmWaterAndHeatingSwitch || splitBaseConsumptionCostsSwitch)){
        downloadPage();
      }else if(count === 3 && heatingFilter && (energyConsumptionCO2EmissionsSwitch || compareHeatingConsumptionBarChartSwitch || co2TaxInfoSwitch)){
        downloadPage();  
      }else if(count === 4 && (arbitraryBoardInfoSwitch || (heatingFilter && energyAdviceCenterInfoSwitch) || (heatingFilter && energyLevelsInfoSwitch))){
        downloadPage();
      }
      else{
        this.downloadPdfFromServer(count+1);
      }
      
    }else{
      downloadStatus.textContent=`PDF-Dokumente zusammenfügen...`;
      const propertyName= this.props.currentProperty?.propertyAdress?.streetno ? this.props.currentProperty?.propertyAdress?.streetno : this.props.currentProperty.name;
      const rentalUnitName= this.state.invoiceData?.rentalUnitName;
      const tenantName= this.state.invoiceData?.tenantName;
      try {
        const pdfBytes = this.mergePdfs(this.state.allPdfs);
        pdfBytes.then(function(result) {
            var blob = new Blob([result], {type: "application/pdf"});
            var link = document.createElement('a');
            let url = window.URL.createObjectURL(blob);
            link.href = url;
  
            
  
            if(messagePreview){
              getPdfUrl(url, blob);
            }else{
              //var fileName = reportName;
              link.download = `${propertyName}-${rentalUnitName}-${tenantName ? tenantName.replace(/,/g, '_') : 'Mieter'}.pdf`;
              //link.download = 'testing_123.pdf';
  
              link.click();
  
              setTimeout(() => {
                  closeWindow();
              }, 500);
            }
        }).catch(e=> console.error('mergePdfsError: ', e));  
      } catch (error) {
        console.error('mergePdfsError: ', error);
      }
      
    }
  }

  convertToBase64= async (data)=>{
    try {
        var reader = new FileReader();
        reader.readAsDataURL(data); 

        const setState=(base64)=>{
          console.log('setState_base64: ', base64);
        // this.setState({customImageBase64: base64 ? base64 : null});
          return base64;
        }
        
        reader.onloadend = function() {
        var base64data = reader.result;                
        console.log('base64data: ', base64data);
        setState(base64data);
        }
    } catch (error) {
        console.log('convertToBase64Error: ', error);
    }
  }

  async convertBlobToArrayBuffer(blob) {
    console.log('convertBlobToArrayBuffer', blob);
    const buf = await blob.arrayBuffer();
    return buf;
  }

  handleDownloadPdf(response){
    if(response.status && response.statuscode === 200){
      console.log('handleDownloadPdf: ', response);
    }
  }

  _getOccupationReadingTenants(tenantId) {
    const propertyid = this.props.currentProperty && this.props.currentProperty.id;
    let ubData = this.props.utilityBillingData.find((ub) => ub.id == this.props.currentDataId)
    console.log('_getOccupationReadingTenants: ', ubData);
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.meter_api_base_url +
      'occupationreadings/occupationReadingForTenant?TenantId=' +
      tenantId +
      '&BillingPeriodId=' +
      (ubData?.billingPeriodId ? ubData?.billingPeriodId : ubData?.billingPeriod?.id) +
      '&PropertyId=' +
      propertyid,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleOccupationReadingTenantResponse',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  _handleOccupationReadingTenantResponse(response) {
    console.log(response, 'occupation api meter');
    if (response.status === true && response.statuscode === 401) {
      localStorage.clear();
      window.location.reload();
    }

    if (response.status === true && response.statuscode === 200) {
      const tenantOccupationReadings = MeterDataHandler.getTenantOccupationReadings(response.result);
      if (tenantOccupationReadings) {
        const startOccasion = tenantOccupationReadings.periodStartReading.occasion;
        const endOccasion = tenantOccupationReadings.periodEndReading.occasion;
        const occupancyDate = this.getOccupationPeriodDate(
          tenantOccupationReadings.periodStart,
          tenantOccupationReadings.periodEnd
        );
        const disableRadioSelection = {
          disableMoveIn:
            tenantOccupationReadings.periodStartReading.occasion === 'move-in' ||
              tenantOccupationReadings.periodEndReading.occasion === 'move-in'
              ? false
              : true,
          disableAnnual:
            tenantOccupationReadings.periodStartReading.occasion === 'annual' ||
              tenantOccupationReadings.periodEndReading.occasion === 'annual'
              ? false
              : true,
          disableMoveOut:
            (tenantOccupationReadings.periodStartReading.occasion === 'move-out' && tenantOccupationReadings.tenantFullName !== '(leer)') ||
              (tenantOccupationReadings.periodEndReading.occasion === 'move-out' && tenantOccupationReadings.tenantFullName !== '(leer)')
              ? false
              : true,
        };
        this.setState(
          {
            tenantOccupationReadings,
            occupancyDate,
            defaultOccasion: tenantOccupationReadings.tenantFullName === '(leer)' ? 'annual' : startOccasion || endOccasion,
            disableRadioSelection,
          },
          () => this.updateOccasion()
        );

        // document.getElementById('errorattop').style.display = 'none';
        console.log('response _handleOccupationReadingTenantResponse', tenantOccupationReadings);
      } else {
        //this.renderErrorMessage(lang.newKeys.text_error_Tenant_readings_not_found);
        this.setState({ disableUpdation: true, readings: [], areReadingsFetched: true }, () => {
           this.checkAndDownloadPDF();
        });
      }
    } else {
      //this.renderErrorMessage(lang.newKeys.text_error_no_reading_found);
      this.setState({ disableUpdation: true, readings: [], areReadingsFetched: true }, () => {
         this.checkAndDownloadPDF();
      });
    }
    //this.ShowLoader();
    console.log(this.state.readings, 'data to show meter 1');
  }

  getHeatingCosts = (addEmptyHC = false) => {
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.ub_api_base_url + 'heatingCosts?utilityBillingId=' + this.props.currentDataId,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handleHeatingCostsResponse',
      { addEmptyHC },
      false,
      '',
      {
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };

  _handleHeatingCostsResponse =(response)=>{
    console.log('_handleHeatingCostsResponse: ', response);
    if(response.status){
      this.setState({heatingCosts: response.result});
    }
  }

  render() {
    // hellohousing's logo, or a partner's while the account has a partner plan (#2357).
    const defaultLogo = getPdfDefaultLogo(this.props.currentSubscription, Logo, this.props.accountData);
    // const data = this.getAllData();
    // const balance = this.calculateBalance(data);
    const { showEmpty, utilityData, utilityBillTableData, meterReadingsSwitch, compositionOfHeatingCostsSwitch, costSplitWarmWaterAndHeatingSwitch, splitBaseConsumptionCostsSwitch, energyConsumptionCO2EmissionsSwitch, compareHeatingConsumptionBarChartSwitch, energyLevelsInfoSwitch, arbitraryBoardInfoSwitch, energyAdviceCenterInfoSwitch, co2TaxInfoSwitch, heatingCosts, vatSwitch, laborCostSwitch, customImageBase64, logo, barChartUrl, houseTenantAverageBase64Url, invoiceData, selectedTenantData, isPreTaxInfoHidden, heatingFilter } = this.state;
    const {isLogoHidden} = this.props;
    console.log(utilityData);
    console.log('customImageBase64: ', customImageBase64);

    console.log('heatingCosts: ', heatingCosts);

    console.log('logo: ', logo);

    console.log('houseTenantAverageBase64Url: ', houseTenantAverageBase64Url);

    console.log('invoiceData: ', invoiceData);

    const commercialTenantWithVatSwitch = vatSwitch && !isStarterTier(this.props.currentSubscription) && (selectedTenantData?.tenantOccupation.contractType === 'Default' || selectedTenantData?.tenantOccupation.contractType === 'commercial' || selectedTenantData?.tenantOccupation.contractType === 'self');
    const sumOfVAT = selectedTenantData?.totalVATAmount ? selectedTenantData?.totalVATAmount : 0;
    const netUtilityBillingCost = (selectedTenantData && selectedTenantData?.tenantRows ? this.calculateTotal(selectedTenantData?.tenantRows.length - 1, false) : selectedTenantData?.totalAllocations) - sumOfVAT;
    const VAT = (isPreTaxInfoHidden ? (selectedTenantData && selectedTenantData?.tenantRows ? this.calculateTotal(selectedTenantData?.tenantRows.length - 1, false) : selectedTenantData?.totalAllocations) : netUtilityBillingCost) * 0.19;
    const grossUtilityBillingCost = !isPreTaxInfoHidden ? (netUtilityBillingCost + VAT) : ((selectedTenantData && selectedTenantData?.tenantRows ? this.calculateTotal(selectedTenantData?.tenantRows.length - 1, false) : selectedTenantData?.totalAllocations) + VAT);
    const creditAmount = selectedTenantData ? selectedTenantData?.totalAdvancePayments - grossUtilityBillingCost : 0;

    console.log('creditAmount: ', creditAmount, selectedTenantData, grossUtilityBillingCost);
    
    // Encode the SVG as base64
    //console.log('b64: ', b64);
    // const data = {
    //     currentTenant:{},
    //     allTenantBills:[]
    // };
    // if ((Object.keys(data.currentTenant).length == 0 && data.allTenantBills.length == 0) || showEmpty) {
    //   return <EmptyStateContainer heading={lang.utility.text_no_tenant_bills} icon={tap} showBtn={false} />;
    // }

    return (
      <div //style={{ overflow: 'auto' }} 
      style={{fontFamily: 'Inter,sans-serif'}}
      id={'mainDiv'}>
        <div>
          <img src={this.props.companyLogoEnable === 'UserDefined' ? customImageBase64 !== null ? customImageBase64 : defaultLogo : defaultLogo} id='logo' alt="logo" style={{height: this.props.companyLogoEnable === 'UserDefined' && this.props.accountData.pictureLocation !== null && 38}}/>
        </div>
        {/* <ReactToPdf targetRef={ref} filename="billing-statement.pdf" scale={0.65} onComplete={() => {
          // setTimeout(() => {
          //   window.close()
          // }, 1000);
        }} >
          {({ toPdf }) => (
            <button style={{ display: 'none' }} onClick={toPdf}>Generate pdf</button>
          )}
        </ReactToPdf> */}
        {/* <button onClick={this.printDocument}>Generate pdf</button> */}
        {/* <div style={{ width: '100vw', height: '100vh', position: 'absolute', zIndex: 1000, background:'red' }}></div> */}
          <div
            ref={ref}
            id={'divToPrint0'}
            style={{fontFamily: 'Inter,sans-serif', maxWidth: '186mm', width: '100%',}}
          >
            {isLogoHidden === false ?
            <div style={{ marginBottom: 48 }}>
              <img src={this.props.companyLogoEnable ? customImageBase64 !== null ? customImageBase64 : defaultLogo : defaultLogo} //id='logo' 
              alt="logo" style={{height: this.props.companyLogoEnable === 'UserDefined' && this.props.accountData.pictureLocation !== null ? '62.5px' : '56px'}}/>
            </div>
            :
            <div style={{marginBottom: 48}}/>}
            <div style={{ marginBottom: 38, //, marginTop: '-50pt'
            }}>
              <span style={{fontWeight: '500', fontSize: '17pt'}}>Betriebskostenabrechnung</span>
              {/* <p style={{ fontSize: '7pt', marginBottom: '2mm', color: '#767676' }}>{utilityData.date}</p> */}
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'start', alignItems: 'flex-start' }}>
              <div style={{ width: "20%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676' }}>Mieter</p>
                <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'normal', textOverflow: 'ellipsis' }}>
                  {this.state.invoiceData?.tenantName}
                </p>
              </div>
              <div style={{ width: "20%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676' }}>Immobilie</p>
                <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'normal', wordBreak: 'break-all', textOverflow: 'ellipsis', width: '85%' }}>
                  {this.props.currentProperty?.propertyAdress?.streetno ? this.props.currentProperty?.propertyAdress?.streetno : this.props.currentProperty.name}
                </p>
              </div>
              <div style={{ width: "20%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676' }}>Mieteinheit</p>
                <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {this.state.invoiceData?.rentalUnitName}
                </p>
              </div>
              <div style={{ width: "20%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676' }}>Datum</p>
                <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {moment().format('DD.MM.YYYY')}
                </p>
              </div>

              <div style={{ width: "20%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676' }}>Abrechnungszeitraum</p>
                <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {this.state.invoiceData?.tenantOccupation?.startDate && this.state.invoiceData?.tenantOccupation?.endDate
                    ? `${moment(this.state.invoiceData.tenantOccupation?.startDate).format('DD.MM.YYYY')} - ${moment(this.state.invoiceData.tenantOccupation?.endDate).format('DD.MM.YYYY')}`
                    : ''
                  }
                </p>
              </div>

              <div style={{ width: "20%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676' }}>Anzahl Abrechnungstage</p>
                <p style={{ fontSize: '7.5pt', marginBottom: '2mm', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                  {this.state.invoiceData?.tenantOccupation?.totalDays}
                </p>
              </div>
              <div style={{ width: "20%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676' }}>Gesamte Betriebskosten</p>
                <p
                  style={{
                    fontSize: '7.5pt',
                    marginBottom: '2mm',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    color:
                      (this.state.invoiceData && this.state.invoiceData.totalAllocatedUtilityCosts) < 0
                        ? 'red'
                        : '#000000',
                  }}
                >
                  {commercialTenantWithVatSwitch ? accounting.formatMoney(grossUtilityBillingCost, '€', 2, '.', ',', '%v %s') :
                  this.state.invoiceData
                    ? formatNumber(
                        this.state.invoiceData.totalAllocatedUtilityCosts,
                        true
                      )
                    : '0,00€'}
                </p>
              </div>
              <div style={{ width: "20%", display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676' }}>Vorauszahlungen</p>
                <p
                  style={{
                    fontSize: '7.5pt',
                    marginBottom: '2mm',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    color:
                      (this.state.invoiceData && this.state.invoiceData.totalAdvancePayments) < 0
                        ? 'red'
                        : '#000000',
                  }}
                >
                  {this.state.invoiceData
                    ? formatNumber(
                        this.state.invoiceData.totalAdvancePayments,
                        true
                      )
                    : '0,00€'}
                </p>
              </div>
              <div style={{ width: 270, display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <p style={{ fontSize: '7pt', marginBottom: '0mm', color: '#767676' }}>
                  {this.state.invoiceData ? 
                    (commercialTenantWithVatSwitch ?
                      creditAmount >= 0 
                      : 
                      this.state.invoiceData.totalAdvancePayments - this.state.invoiceData.totalAllocatedUtilityCosts >= 0) ? lang.utility.text_balance_positive : lang.utility.text_balance_negative : lang.utility.text_balance}
                </p>
                <p
                  style={{
                    fontSize: '7.5pt',
                    marginBottom: '2mm',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    color:
                    commercialTenantWithVatSwitch ?
                      creditAmount < 0
                    :
                    (this.state.invoiceData && this.state.invoiceData.totalAdvancePayments - this.state.invoiceData.totalAllocatedUtilityCosts) < 0
                      ? 'red'
                      : '#000000',
                  }}
                >
                  {commercialTenantWithVatSwitch ?
                    (creditAmount > 0 ? '+' : '') + accounting.formatMoney(creditAmount, '€', 2, '.', ',', '%v %s')
                  :
                  this.state.invoiceData
                    ? (this.state.invoiceData.totalAdvancePayments - this.state.invoiceData.totalAllocatedUtilityCosts > 0 ? '+' : '') + formatNumber(
                        this.state.invoiceData.totalAdvancePayments - this.state.invoiceData.totalAllocatedUtilityCosts,
                        true
                      )
                    : '0,00€'}
                </p>
              </div>
            </div>
            <>
              {this.state.selectedTenantData &&
              this.state.selectedTenantData.tenantRows &&
              this.state.selectedTenantData.tenantRows.length ? 
              <>
                <UtilityBillTable
                selectedTenantData={this.state.selectedTenantData}
                utilityData={utilityData}
                warmWaterCostTypeFound={this.state.warmWaterCostTypeFound}
                tableCells={this.getTableLabels()}
                billingTemplate={true}
                style={{marginTop: '20px', background: 'transparent'}}
                invoiceData={this.state.invoiceData}
                vatSwitch={vatSwitch}
                laborCostSwitch={laborCostSwitch}
                messagePreview={true}
                isPreTaxInfoHidden={isPreTaxInfoHidden}
                />
              </>
              :
              <div id='emptyState' style={{marginTop: '250px'}}>
                  <div>
                      <div>
                          <div className="main-container empty-state-container" style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                            <div className="icon-container" style={{background: 'transparent', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', borderRadius: '4px'}}>
                                <img id='emptyLogo' src={tap} style={{margin: '12px'}} className="empty-state-icon" alt="empty" />
                            </div>
                            <div style={{marginTop: '20px'}}>
                              <span className="empty-state-heading" style={{
                                marginTop: '16px',
                                fontFamily: 'Inter, sans-serif',
                                fontStyle: 'normal',
                                fontWeight: '500',
                                fontSize: '11px',
                                lineHeight: '20px',
                                color: 'rgb(19, 19, 92, 0.8)'
                              }}>{'Es konnte noch keine Betriebskostenabrechnung erstellt werden.'}</span>
                            </div>
                            <div style={{marginTop: '12px'}}>
                              <span className="empty-state-subheading" style={{
                                marginTop: '0px',
                                marginBottom: '12px',
                                fontStyle: 'normal',
                                fontWeight: '400',
                                fontSize: '10px',
                                lineHeight: '16px',
                                color: 'rgb(114, 114, 147, 0.6)',
                                fontFamily: 'Inter, sans-serif',
                                textAlign: 'center'
                              }}>{'Die Betriebskostenabrechnung enthält keine Kostenpositionen.'}</span>
                            </div>                            
                            {/* <h5 style={{fontSize: 12, fontFamily: 'Inter, sans-serif'}} className="empty-state-subheading">{'Bitte legen Sie Zähler an bevor Sie mit der Ablesung beginnen.'}</h5> */}
                          </div>
                      </div>
                  </div>
              </div>
              }
            </>
          </div>
          <div
          id={'divToPrint1'}
          style={{maxWidth: '186mm', width: '100%', fontFamily: 'Inter,sans-serif'}}>
          {meterReadingsSwitch && this.state.readings && 
            <>
              {isLogoHidden === false ?
              <div style={{ marginBottom: 48 }}>
                <img src={this.props.companyLogoEnable === 'UserDefined' ? customImageBase64 !== null ? customImageBase64 : defaultLogo : defaultLogo} //id='logo' 
                alt="logo" style={{height: this.props.companyLogoEnable === 'UserDefined' && this.props.accountData.pictureLocation !== null ? '62.5px' : '56px'}} />
              </div>
              :
              <div style={{marginBottom: 48}}/>}
              <div style={{ marginBottom: 38 }}>
                <span style={{fontWeight: '500', fontSize: '17pt'}}>Ablesungen und Verbräuche</span>
              </div>
              {this.state.readings.meterReadings && this.state.readings.meterReadings.length > 0 ?
              <MeterReadingsTable
                readings={this.state.readings}
                utilityData={utilityData}
                billingTemplate={true}
                messagePreview={true}
              />
            :
              <div id='emptyStateMeter' style={{marginTop: '250px'}}>
                  <div>
                      <div>
                          <div className="main-container empty-state-container" style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                            <div className="icon-container" style={{background: 'transparent', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', borderRadius: '4px'}}>
                                <img id='emptyLogoMeter' src={MeterIcon} style={{margin: '12px 15px'}} className="empty-state-icon" alt="empty" />
                            </div>
                            <div style={{marginTop: '20px'}}>
                              <span style={{
                                marginTop: '16px',
                                fontFamily: 'Inter, sans-serif',
                                fontStyle: 'normal',
                                fontWeight: '500',
                                fontSize: '11px',
                                lineHeight: '20px',
                                color: 'rgb(19, 19, 92, 0.8)'
                              }} className="empty-state-heading">{'Keine Ablesungen vorhanden.'}</span>
                            </div>
                            <div style={{marginTop: '12px'}}>
                              <span style={{
                                marginTop: '0px',
                                marginBottom: '12px',
                                fontStyle: 'normal',
                                fontWeight: '400',
                                fontSize: '10px',
                                lineHeight: '16px',
                                color: 'rgb(114, 114, 147, 0.6)',
                                fontFamily: 'Inter, sans-serif',
                                textAlign: 'center'
                              }} className="empty-state-subheading">{'Für diesen Mieter liegen keine Ablesungen für die Abrechnungsperiode vor.'}</span>
                            </div>
                          </div>
                      </div>
                  </div>
              </div>}
            </>}
          </div>

          <div
          id={'divToPrint2'}
          style={{maxWidth: '186mm', width: '100%', fontFamily: 'Inter,sans-serif'}}>
          {heatingFilter && this.state.selectedTenantData && 
            <>
              {isLogoHidden === false ?
              <div style={{ marginBottom: 48 }}>
                <img src={this.props.companyLogoEnable === 'UserDefined' ? customImageBase64 !== null ? customImageBase64 : defaultLogo : defaultLogo} //id='logo' 
                alt="logo" style={{height: this.props.companyLogoEnable === 'UserDefined' && this.props.accountData.pictureLocation !== null ? '62.5px' : '56px'}} />
              </div>
              :
              <div style={{marginBottom: 48}}/>}
              {compositionOfHeatingCostsSwitch && 
              <>
              <div style={{ marginBottom: 38 }}>
                <span style={{fontWeight: '500', fontSize: '17pt'}}>Zusammensetzung der Heizungskosten</span>
              </div>
              {heatingCosts && heatingCosts.length > 0 ?
                <CompositionOfHeatingCostsTable
                selectedTenantData={this.state.selectedTenantData}
                utilityData={utilityData}
                warmWaterCostTypeFound={this.state.warmWaterCostTypeFound}
                heatingCosts={this.state.heatingCosts}
                print={true}
                messagePreview={true}
                //isTablet={isTablet}
              />
              :
              <div id='emptyStateHeatingCosts'>
                  <div>
                      <div>
                          <div className="main-container empty-state-container" style={{width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                            <div className="icon-container" style={{background: 'transparent', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', borderRadius: '4px'}}>
                                <img id='emptyLogoMeter' src={tap} className="empty-state-icon" style={{margin: '12px'}} alt="empty" />
                            </div>
                            <div style={{marginTop: '20px'}}>
                              <span style={{
                                marginTop: '16px',
                                fontFamily: 'Inter, sans-serif',
                                fontStyle: 'normal',
                                fontWeight: '500',
                                fontSize: '11px',
                                lineHeight: '20px',
                                color: 'rgb(19, 19, 92, 0.8)'
                              }} className="empty-state-heading">{'Es liegen keine Heizkostendetails vor.'}</span>
                            </div>
                            <div style={{marginTop: '12px'}}>
                              <span style={{
                                marginTop: '0px',
                                marginBottom: '12px',
                                fontStyle: 'normal',
                                fontWeight: '400',
                                fontSize: '10px',
                                lineHeight: '16px',
                                color: 'rgb(114, 114, 147, 0.6)',
                                fontFamily: 'Inter, sans-serif',
                                textAlign: 'center'
                              }} className="empty-state-subheading">{'Es liegen keine Details zur Zusammensetzung der Heizkosten vor.'}</span>
                            </div>
                          </div>
                      </div>
                  </div>
              </div>}
              </>}
              {costSplitWarmWaterAndHeatingSwitch &&
              <>
              <div style={{ marginBottom: 38, marginTop: 38 }}>
                <span style={{fontWeight: '500', fontSize: '17pt'}}>Aufteilung Heizkosten in Kosten für Warmwasser und Heizkosten</span>
              </div>
              <CostSplitWarmWaterAndHeatingTable
                utilityBilling={this.props.utilityBillingData.find((ub) => ub.id == this.props.currentDataId)}
                messagePreview={true}
              />
              </>}
              {splitBaseConsumptionCostsSwitch &&
              <>
              <div style={{ marginBottom: 38, marginTop: 38, display: 'flex' }}>
                <span style={{fontWeight: '500', fontSize: '17pt'}}>Aufteilung Heizkosten in Grundkosten und Verbrauchskosten</span>
              </div>
              <SplitBaseConsumptionCosts
                selectedTenantData={this.state.selectedTenantData}
                utilityData={utilityData}
                warmWaterCostTypeFound={this.state.warmWaterCostTypeFound}
                heatingCosts={this.state.heatingCosts}
                messagePreview={true}
              />
              </>}
            </>}
          </div>

          <div
          id={'divToPrint3'}
          style={{maxWidth: '210mm', 
          width: '100%', fontFamily: 'Inter,sans-serif'}}>
          {heatingFilter && this.state.selectedTenantData && 
            <>
              {isLogoHidden === false ?
              <div style={{ marginBottom: 48 }}>
                <img src={this.props.companyLogoEnable === 'UserDefined' ? customImageBase64 !== null ? customImageBase64 : defaultLogo : defaultLogo} //id='logo' 
                alt="logo" style={{height: this.props.companyLogoEnable === 'UserDefined' && this.props.accountData.pictureLocation !== null ? '62.5px' : '56px'}} />
              </div>
              :
              <div style={{marginBottom: 48}}/>}
              {energyConsumptionCO2EmissionsSwitch &&
              <>
              <div style={{ marginBottom: 38, marginTop: 38, display: 'flex' }}>
                <span style={{marginTop: '4px', fontWeight: '500', fontSize: '17pt'}}>{'Energieverbrauch & CO'}<span style={{verticalAlign: 'sub', fontSize: '12px'}}>2</span>{'-Emissionen'}</span>
              </div>
              <EnergyConsumptionAndCO2EmissionsCostTable
                selectedTenantData={this.state.selectedTenantData}
                utilityData={utilityData}
                warmWaterCostTypeFound={this.state.warmWaterCostTypeFound}
                heatingCosts={this.state.heatingCosts}
                messagePreview={true}
              />
              </>}
                
              {co2TaxInfoSwitch &&
              <>
                <div style={{ marginBottom: 38, marginTop: 38, display: 'flex' }}>
                  <span style={{marginTop: '4px', fontWeight: '500', fontSize: '17pt'}}>{'Berechnung der CO'}<span style={{verticalAlign: 'sub', fontSize: '12px'}}>2</span>{'-Steuer'}</span>
                </div>
                <CalculationOfCO2TaxTable
                  selectedTenantData={this.state.selectedTenantData}
                  utilityData={utilityData}
                  warmWaterCostTypeFound={this.state.warmWaterCostTypeFound}
                  heatingCosts={this.state.heatingCosts}
                  messagePreview={true}
                />
              </>}

              {compareHeatingConsumptionBarChartSwitch &&
              <>
              <div style={{ marginBottom: 20, marginTop: 38, display: 'flex' }}>
                <span style={{fontWeight: '500', fontSize: '17pt'}}>{'Entwicklung Heizungsverbrauch und Heizungskosten'}</span>
              </div>
              <div style={{whiteSpace: 'nowrap', display: 'flex'}}>
                <div style={{display: 'flex', flexDirection: 'column', padding: '20px 20px 20px 0px'}}>
                  <span style={{fontSize: '10pt', fontWeight: '700', marginBottom: '10pt'}}>{'Energieverbrauch (kWh)'}</span>
                  <img style={{maxWidth: '93mm', marginTop: '20px'}} id='consumption-chart-image'/>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', padding: '20px 30px 20px 20px'}}>
                  <span style={{fontSize: '10pt', fontWeight: '700', marginBottom: '10pt'}}>{'Energiekosten (€)'}</span>
                  <img style={{maxWidth: '93mm', marginTop: '20px'}} id='cost-chart-image'/>
                </div>
              </div>
              </>}
            </>}
          </div>

          <div
          id={'divToPrint4'}
          style={{maxWidth: '210mm', 
          width: '100%', fontFamily: 'Inter,sans-serif'}}>
            {isLogoHidden === false ?
            <div style={{ marginBottom: 48 }}>
              <img src={this.props.companyLogoEnable === 'UserDefined' ? customImageBase64 !== null ? customImageBase64 : defaultLogo : defaultLogo} //id='logo' 
              alt="logo" style={{height: this.props.companyLogoEnable === 'UserDefined' && this.props.accountData.pictureLocation !== null ? '62.5px' : '56px'}} />
            </div>
            :
            <div style={{marginBottom: 48}}/>}

            {heatingFilter && this.state.selectedTenantData && energyLevelsInfoSwitch &&
            <>
              <div style={{ marginBottom: 20, marginTop: 38, display: 'flex'}}>
                <span style={{fontWeight: '500', fontSize: '17pt'}}>{'Energieverbrauch im Hausvergleich'}</span>
              </div>
              <img style={{maxWidth: '100%'}} id='house-tenant-average-image'/>
            </>}

            {heatingFilter && energyAdviceCenterInfoSwitch &&
            <>
            <div style={{ marginBottom: 20, marginTop: 38, display: 'flex' }}>
              <span style={{fontWeight: '500', fontSize: '17pt'}}>Energieberatung der Verbraucherzentrale</span>
            </div>
            {<div style={{background: 'white', padding: '20px 0px', width: '100%', display: 'flex', flexDirection: 'column'}}>
              <span style={{fontWeight: '400', fontSize: '12px', fontFamily: 'Inter, sans-serif'}}>Bei der Energieberatung der Verbraucherzentrale erhalten Sie Tipps und Beratung zur Reduzierung des Heizungsverbrauches.</span>
                <span style={{fontWeight: '400', fontSize: '12px', fontFamily: 'Inter, sans-serif'}}><h5 style={{marginBottom: '5px'}}>Webseite</h5>
                  <a style={{color: '#5555FF', textDecoration: 'none'}} href='https://verbraucherzentrale-energieberatung.de/heizen/heizkostenabrechnung/' target='_blank'>
                    https://verbraucherzentrale-energieberatung.de/heizen/heizkostenabrechnung/
                  </a>
                </span>
              </div>}
            </>}

            {arbitraryBoardInfoSwitch &&
            <>
            <div style={{ marginBottom: 20, marginTop: 38, display: 'flex' }}>
              <span style={{fontWeight: '500', fontSize: '17pt'}}>Kontaktinformationen zur Schlichtungsstelle</span>
            </div>
            {<div style={{background: 'white', padding: '20px 0px', width: '100%', display: 'flex', flexDirection: 'column'}}>
              <span style={{fontWeight: '400', fontSize: '12px', fontFamily: 'Inter, sans-serif'}}>Die Universalschlichtungsstelle des Bundes hilft Streitigkeiten im Rahmen der Betriebskostenabrechnung beizulegen.</span> 
              <span style={{fontWeight: '400', fontSize: '12px', fontFamily: 'Inter, sans-serif'}}><h5 style={{marginBottom: '5px'}}>Webseite</h5><a style={{color: '#5555FF', textDecoration: 'none'}} href='https://www.universalschlichtungsstelle.de'>https://www.universalschlichtungsstelle.de</a></span>
              <span style={{fontWeight: '400', fontSize: '12px', fontFamily: 'Inter, sans-serif'}}><h5 style={{marginBottom: '5px'}}>Email</h5><a style={{color: '#5555FF', textDecoration: 'none'}} href='mailto:mail@universalschlichtungsstelle.de'>mail@universalschlichtungsstelle.de</a></span>
              <span style={{fontWeight: '400', fontSize: '12px', fontFamily: 'Inter, sans-serif'}}><h5 style={{marginBottom: '5px'}}>Anschrift</h5>Straßburger Str. 8<br/><span>77694 Kehl</span><br/><span>Deutschland</span></span>
            </div>}
            </>}
          </div>
          {compareHeatingConsumptionBarChartSwitch && this.state.selectedTenantData && 
          this.state.selectedTenantData && Object.keys(this.state.selectedTenantData).find((key)=> key === 'previousTenantHeatingEnergyAmountkWh') &&
          <CompareHeatingConsumptionBarChart
            selectedTenantData={this.state.selectedTenantData}
            utilityData={utilityData}
            messagePreview={true}
            //setBarChartUrl={(barChartUrl)=> this.setState({barChartUrl})}
          />}
          {energyLevelsInfoSwitch && this.state.selectedTenantData && 
          <BenchmarkingAverageUserBuilding
          selectedTenantData={this.state.selectedTenantData}
          utilityData={utilityData}
          messagePreview={true}
          // warmWaterCostTypeFound={this.state.warmWaterCostTypeFound}
          // heatingCosts={this.state.heatingCosts}
          // isTablet={isTablet}
          />
          }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  // console.log('stateee', state.UtilityBillingReducer)
  return {
    // allUtilityBills: state.UtilityBillingReducer.utilityBillingData,
    currentProperty: state.generalReducer.property,
    currentDataId: state.UtilityBillingReducer.currentBillingId,
    tenantBills: state.UtilityBillingReducer.utilityBillingData,
    utilityBillingData: state.UtilityBillingReducer.utilityBillingData,
    companyLogoEnable: state.generalReducer.companyLogoEnable,
    accountData: state.generalReducer.accountData,
    currentSubscription: state.generalReducer.currentSubscription,
    propertySelected: state.generalReducer.property,
    isLogoHidden: state.generalReducer.isLogoHidden,
    profileData: state.generalReducer.profile
  };
};

const mapDispatchToProps = {
  setTenantBills,
};

export default connect(mapStateToProps, mapDispatchToProps)(UtilityBillsTable);